import { Dispatch } from "redux";
import { RootState } from "../reducers";
import { Conversation, User, Message } from "../types";
import { createChatApiClient } from "../libs/createHttp";
type GetState = () => RootState;

export const LOAD_CONVERSATIONS = "chat/LOAD_CONVERSATIONS";
export const LOAD_MORE_CONVERSATIONS = "chat/LOAD_MORE_CONVERSATIONS";
export const LOAD_CONVERSATION = "chat/LOAD_CONVERSATION";

export const SEND_MESSAGE = "chat/SEND_MESSAGE";
export const SEND_TYPING = "chat/SEND_TYPING";
export const SEND_TYPING_STOP = "chat/SEND_TYPING_STOP";

export const MESSAGE_RECEIVED = "chat/MESSAGE_RECEIVED";
export const MESSAGE_READ = "chat/MESSAGE_READ";
export const MESSAGE_READ_BY_ME = "chat/MESSAGE_READ_BY_ME";
export const MESSAGE_DELETED = "chat/MESSAGE_DELETED";
export const TYPING = "chat/TYPING";
export const TYPING_STOPPED = "chat/TYPING_STOPPED";
export const NEW_CONVERSATION = "chat/NEW_CONVERSATION";
export const SELECT_CONVERSATION = "chat/SELECT_CONVERSATION";
export const CREATE_CONVERSATION = "chat/CREATE_CONVERSATION";
export const CONVERSATION_CREATED = "chat/CONVERSATION_CREATED";
export const CONVERSATION_ADDED = "chat/CONVERSATION_ADDED";
export const CONVERSATION_READ = "chat/CONVERSATION_READ";
export const LOAD_PREVIOUS_MESSAGES = "chat/LOAD_PREVIOUS_MESSAGES";
export const CLOSE_COMPOSER = "CLOSE_COMPOSER";

export const CONVERSATIONS_LIMIT = 20;

const http = createChatApiClient();

export function loadConversation(conversationId: string) {
	return async (dispatch: Dispatch, getState: GetState) => {
		try {
			const state = getState().chat;

			if (state.composerOpen) {
				return;
			}

			if (state.activeConversationId !== conversationId) {
				if (state.conversations.has(conversationId)) {
					dispatch(selectConversation(conversationId));
				} else {
					const res = await http.get<Conversation>(`/conversations/${conversationId}`);
					dispatch({
						type: LOAD_CONVERSATION,
						conversation: res,
					});
				}
			}
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function loadConversations(limit = CONVERSATIONS_LIMIT) {
	return async (dispatch: Dispatch, getState: GetState) => {
		try {
			const state = getState();

			if (state.chat.conversations.count() === 0) {
				const res = await http.get<{ conversations: Conversation[] }>("/conversations", {
					limit,
				});
				dispatch({
					type: LOAD_CONVERSATIONS,
					conversations: res.conversations,
				});
			}
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function sendMessage(message: string, conversationId: string) {
	return {
		type: SEND_MESSAGE,
		message,
		conversationId,
	};
}

export function sendTyping(conversationId: string, userId: string) {
	return {
		type: SEND_TYPING,
		conversationId,
		userId,
	};
}

export function sendTypingStop(conversationId: string, userId: string) {
	return {
		type: SEND_TYPING_STOP,
		conversationId,
		userId,
	};
}

export function createConversation(message: string, partners: User[]) {
	const partnerUUIDs = partners.map(partner => partner.userId);
	return {
		type: CREATE_CONVERSATION,
		message,
		partnerUUIDs,
	};
}

export function messageReceived({ messageType, payload }: { messageType: string; payload: string }) {
	return {
		type: MESSAGE_RECEIVED,
		messageType,
		payload,
	};
}

export function messageRead({ messageType, payload }: { messageType: string; payload: string }) {
	return {
		type: MESSAGE_READ,
		messageType,
		payload,
	};
}

export function messageReadByMe(messageIds: string[]) {
	return {
		type: MESSAGE_READ_BY_ME,
		messageIds,
	};
}

export function messageDeleted({ messageType, payload }: { messageType: string; payload: string }) {
	return {
		type: MESSAGE_DELETED,
		messageType,
		payload,
	};
}

export function typing({ messageType, payload }: { messageType: string; payload: string }) {
	return {
		type: TYPING,
		messageType,
		payload,
	};
}

export function typingStopped({ messageType, payload }: { messageType: string; payload: string }) {
	return {
		type: TYPING_STOPPED,
		messageType,
		payload,
	};
}

export function newConversation() {
	return {
		type: NEW_CONVERSATION,
	};
}

export function selectConversation(id: string) {
	return {
		type: SELECT_CONVERSATION,
		id,
	};
}

export function conversationAdded(conversation: Conversation) {
	return {
		type: CONVERSATION_ADDED,
		conversation,
	};
}

export function loadPreviousMessages(conversationId: string, from: number, count = 20) {
	return async (dispatch: Dispatch): Promise<boolean> => {
		try {
			const { messages } = await http.get<{ messages: Message[] }>(
				`/messages/${conversationId}/previous/${count}/from/${from}`
			);
			dispatch({
				type: LOAD_PREVIOUS_MESSAGES,
				messages,
				conversationId,
			});

			return messages.length === count;
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function loadPreviousConversations(from: number, limit = CONVERSATIONS_LIMIT) {
	return async (dispatch: Dispatch) => {
		try {
			const res = await http.get<{ conversations: Conversation[] }>("/conversations", {
				from,
				limit,
			});
			dispatch({
				type: LOAD_MORE_CONVERSATIONS,
				conversations: res.conversations,
			});
		} catch (error) {
			console.log(error);
			//processError(dispatch, error);
		}
	};
}

export function markConversationRead(conversationId: string) {
	return {
		type: CONVERSATION_READ,
		conversationId,
	};
}

export function closeComposer() {
	return {
		type: CLOSE_COMPOSER,
	};
}
